import { render, staticRenderFns } from "./ViewInterviewPatient.vue?vue&type=template&id=701d6a5e&scoped=true&"
import script from "./ViewInterviewPatient.vue?vue&type=script&lang=js&"
export * from "./ViewInterviewPatient.vue?vue&type=script&lang=js&"
import style0 from "./ViewInterviewPatient.vue?vue&type=style&index=0&id=701d6a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701d6a5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VApp,VBtn,VCol,VContainer,VForm,VIcon,VRow,VTextarea})
